import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Fragment, useCallback, useState } from "react";
import { BiCloudDownload } from "react-icons/bi";
import ReactSelect from "react-select";
import { filterSelectStyles } from "utils/reactSelectStyles";
import { Input, Select } from "styled";
import { useQuery } from "react-query";
import { TD, TH } from "styled/table";
import exportExcel from "utils/exportExcel";
import Modal from "components/Modal";
import {Button} from 'styled'

const contractTypeOptions = [
  { value: 'All', label: 'All' },
  { value: 'CPKM', label: 'CPKM' },
  { value: 'NON CPKM', label: 'NON CPKM' }
];

const InspectionPendingOver90Days = () => {
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [fleetMap, setFleetMap] = useState({});
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [reportData, setReportData] = useState("")
  const [downloading, setDownloading] = useState(false)
  const [enabled, setEnabled] = useState(false)
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [contractType, setContractType] = useState("")
  const [reportType, setReportType] = useState("fleet")
  const [appliedReportType, setAppliedReportType] = useState("fleet")

  const getData = async ()=>{
    setIsLoading(true)
    const dt = await  createDocument("/report/inspectionPendingOver90Days", {
        ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
        dateTo,
        dateFrom,
        ...(contractType && { contractType }),
        reportType,
      },
      )
    // console.log(dt)
    setData(dt);
    setAppliedReportType(reportType)
    setIsLoading(false)
  }

  const getDownloadData = async ()=>{
    setDownloading(true)
    try{
    const dt = await createDocument("/report/inspectionPendingOver90Days", {
      ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
      dateTo,
      dateFrom,
      ...(contractType !== "" && {
        contractType,
      }),
      reportType,
    })
    if(dt){ 
      setReportData(dt)
      let exportData = dt?.data?.map((x, idx) => ({
          "S.N": idx + 1,
          "Fleet Name": `${x?.fleet} (${x?.fleetCity})`,
          ...(reportType === "hub" && { "Hub Name": x?.hubName ?? "-" }),
          "Total Vehicle": x?.vehiclesCount ?? 0,
          Cpkm: x?.cpkmCount ?? 0,
          Service: x?.serviceCount ?? 0,
          "Today": x?.todayCount ?? 0,
          "1-30 Days": (x?.oneToFifteenDaysCount ?? 0) + (x?.sixteenToThirtyDaysCount ?? 0),
          "31-60 days": x?.thirtyOneToSixtyDaysCount ?? 0,
          "61 - 90 Days": x?.sixtyOneToNintyDaysCount ?? 0,
          "Over 91 Days": x?.overNinetyDaysCount ?? 0,
        }));

      exportData.push({
        "Total Vehicle": dt.totalRow?.vehiclesCount ?? 0,
          Cpkm: dt.totalRow?.cpkmCount ?? 0,
          Service: dt.totalRow?.serviceCount ?? 0,
          "Today": dt.totalRow?.todayCount ?? 0,
          "1-30 Days": (dt.totalRow?.oneToFifteenDaysCount ?? 0) + (dt.totalRow?.sixteenToThirtyDaysCount ?? 0),
          "31-60 days": dt.totalRow?.thirtyOneToSixtyDaysCount ?? 0,
          "61 - 90 Days": dt.totalRow?.sixtyOneToNintyDaysCount ?? 0,
          "Over 91 Days": dt.totalRow?.overNinetyDaysCount ?? 0,
      })

      exportExcel(exportData, "inspection-pending-report", true)
    }
  }catch(err){
    console.log(err)
  }
  finally{
    setDownloading(false);
  }
  }

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ? 
        allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) : 
        allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  const getModalFilters = useCallback(() => {
    const hubs = selectedHubs?.includes("all")
      ? getHubOptions()
          ?.filter((item) => item.value !== "all" && item.value !== "clear")
          ?.map((item) => item.value)
          ?.join(",")
      : selectedHubs?.length
      ? selectedHubs.join(",")
      : undefined;
    return {
      ...(hubs && { hubs }),
      ...(contractType && contractType !== "" && { contractType }),
    };
  }, [selectedHubs, contractType, getHubOptions]);

  return (
    <div>
      <div className="w-full px-8 flex flex-wrap lg:flex-nowrap items-end justify-start mt-4 gap-4">
        <label className="w-full py-3 flex flex-col gap-2">
          Select Fleets
          <ReactSelect
            styles={filterSelectStyles}
            className="shadow-md rounded-md"
            options={getFleetOptions()}
            value={
              selectedFleets &&
              selectedFleets?.map((fleet) => {
                return {
                  value: fleet,
                  label: getFleetOptions()?.find(
                    (item) => item?.value === fleet
                  )?.label,
                };
              })
            }
            onChange={(value) => {
              let allValues = value?.map((item) => item.value);
              if (allValues?.includes("clear")) {
                // console.log(allValues)
                setSelectedFleets([]);
                setSelectedHubs([]);
                return;
              }
              if (
                !selectedFleets?.includes("all") &&
                allValues.includes("all")
              ) {
                setSelectedFleets(["all"]);
                return;
              }

              if (selectedFleets.includes("all")) {
                // console.log("first");
                // console.log(getFleetOptions())
                value = value.filter((item) => item.value !== "all");
              }

              let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                value?.map((item) => item.value)?.includes(fleet._id)
              );

              let selectedHubsVal = allHubs?.data?.filter((hub) =>
                selectedHubs?.map((item) => item)?.includes(hub._id)
              );

              setSelectedHubs(
                selectedHubsVal
                  ?.filter((hub) =>
                    selectedFleetsVal?.find(
                      (fleet) => fleet.fleetCode === hub.fleetCode
                    )
                  )
                  .map((hub) => hub._id)
              );

              // console.log({allHubs, selectedHubs})

              setSelectedFleets(value.map((fleet) => fleet.value));
            }}
            name="fleets"
            isMulti={true}
          />
        </label>
        <label className="w-full py-3 flex flex-col gap-2">
          Select Hubs
          <ReactSelect
            styles={filterSelectStyles}
            className="shadow-md rounded-md py-1 "
            options={getHubOptions()}
            value={
              selectedHubs &&
              selectedHubs?.map((hub) => {
                // console.log({hub})
                return {
                  value: hub,
                  label: getHubOptions()?.find((item) => item.value === hub)
                    ?.label,
                };
              })
            }
            onChange={(value) => {
              const allValues = value?.map((item) => item.value);
              // console.log({allValues})
              if (allValues.includes("clear")) {
                setSelectedHubs([]);
                return;
              }
              if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                let selectedFleetCodes = allFleets?.data
                  ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                  ?.map((fleet) => fleet.fleetCode);

                const selectedHubsData = allHubs?.data?.filter((hub) =>
                  selectedFleetCodes?.includes(hub.fleetCode)
                );

                const mp = fleetMap;
                selectedHubsData.map((hub) => {
                  if (selectedFleetCodes?.includes(hub.fleetCode)) {
                    if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                    mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                  }
                });

                setFleetMap(mp);
                setSelectedHubs(["all"]);
              } else {
                // console.log({value})
                value = value.filter((value) => value.value !== "all");
                // console.log({value})
                let selectedFleetCodes = allFleets?.data
                  ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                  ?.map((fleet) => fleet.fleetCode);
                // console.log({allValues})

                const selectedHubsData = allHubs?.data?.filter((hub) =>
                  allValues?.includes(hub._id)
                );
                const mp = {};
                selectedHubsData.map((hub) => {
                  mp[hub.fleetCode] = [];
                });

                selectedHubsData.map((hub) => {
                  if (selectedFleetCodes?.includes(hub.fleetCode)) {
                    if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                    mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                  }
                });

                setFleetMap(mp);
                setSelectedHubs(value.map((hub) => hub.value));
              }
            }}
            name="hubs"
            isMulti={true}
          />
        </label>
        <label className="w-full py-3 flex flex-col gap-2">
          Contract Type
          <ReactSelect
           styles={filterSelectStyles}
            name="contractType"
            className="shadow-md rounded-md"
            value={contractTypeOptions.find(option => option.value === contractType)} 
            onChange={(option) => {
              setContractType(option.value);
            }}
            options={contractTypeOptions}
          />

        </label>
        <label className="w-full py-3 flex flex-col gap-2">
          Report Type
          <Select
            name="reportType"
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
          >
            <option value={"fleet"}>Fleet Wise</option>
            <option value={"hub"}>Hub Wise</option>
          </Select>
        </label>
        <div className="flex items-end gap-2 mb-3">
        <Button
          type="button"
          bgPrimary
          disabled={selectedFleets.length === 0 || selectedHubs.length === 0}
          onClick={() => getData()}
        >
          Search
        </Button>
        {downloading ? (
          "Downloading..."
        ) : selectedFleets.length !== 0 && selectedHubs.length !== 0 ? (
          <BiCloudDownload
            className="w-10 h-10 text-green-500 hover:scale-105 cursor-pointer text-center"
            onClick={async () => {
              await getDownloadData();
            }}
          />
        ) : (
          <></>
        )}
        </div>

      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Fleet Name</TH>
                      {appliedReportType === "hub" && <TH scope="col">Hub Name</TH>}
                      <TH scope="col">Total Vehicle</TH>
                      <TH scope="col">CPKM</TH>
                      <TH scope="col">Service</TH>
                      <TH scope="col">Today</TH>
                      <TH scope="col">1-30 Days</TH>
                      <TH scope="col">31-60 days </TH>
                      <TH scope="col">61 - 90 Days</TH>
                      <TH scope="col">Over 91 Days</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {data &&
                      data.data?.map((d, idx) => (
                        <ViewList
                          key={d?.fleetId ?? idx}
                          data={d}
                          idx={idx}
                          modalFilters={getModalFilters()}
                          reportType={appliedReportType}
                        />
                      ))}
                  </tbody>
                  {data?.totalRow ? <tfoot>
                    <tr className="text-gray-600 font-semibold bg-green-100">
                      <TD></TD>
                      <TD colSpan={appliedReportType === "hub" ? 2 : 1} className="text-left">
                        TOTAL
                      </TD>
                      <TD className="text-center">
                        {data?.totalRow?.vehiclesCount}
                      </TD>
                      <TD className="text-center">
                        {data?.totalRow?.cpkmCount}
                      </TD>
                      <TD className="text-center">
                        {data?.totalRow?.serviceCount}
                      </TD>
                      <TD className="text-center">
                        {data?.totalRow?.todayCount}
                      </TD>
                      <TD className="text-center">
                        {(data?.totalRow?.oneToFifteenDaysCount ?? 0) +
                          (data?.totalRow?.sixteenToThirtyDaysCount ?? 0)}
                      </TD>
                      <TD className="text-center">
                        {data?.totalRow?.thirtyOneToSixtyDaysCount}
                      </TD>
                      <TD className="text-center">
                        {data?.totalRow?.sixtyOneToNintyDaysCount}
                      </TD>
                      <TD className="text-center">
                        {data?.totalRow?.overNinetyDaysCount}
                      </TD>
                    </tr>
                  </tfoot> : <></>}
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InspectionPendingOver90Days;

const ViewList = ({ data, idx, modalFilters = {}, reportType = "fleet" }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ title: "", data: [] });
  const [modalLoading, setModalLoading] = useState(false);

  const modalHandler = useCallback(
    async (title, category) => {
      if (!category) {
        setShowModal(false);
        setModalData({ title: "", data: [] });
        return;
      }
      setModalLoading(true);
      setShowModal(true);
      setModalData({ title, data: [] });
      try {
        const { hubs, ...restFilters } = modalFilters || {};
        const isHubWise = reportType === "hub";
        const body = {
          fleetId: data?.fleetId,
          category,
          ...(isHubWise && data?.hubId && { hubId: data.hubId }),
          ...(!isHubWise && hubs && { hubs }),
          ...restFilters,
        };
        const res = await createDocument(
          "/report/inspectionPendingOver90Days/modalInfo",
          body
        );
        setModalData({ title, data: res?.data ?? [] });
      } catch (err) {
        setModalData({ title, data: [] });
      } finally {
        setModalLoading(false);
      }
    },
    [data?.fleetId, data?.hubId, modalFilters, reportType]
  );

  const closeModal = useCallback(() => {
    setShowModal(false);
    setModalData({ title: "", data: [] });
  }, []);

  return (
    <Fragment>
      {showModal && (
        <Modal
          handleClick={closeModal}
          title={modalData.title}
          className="max-w-2xl"
        >
          <h1 className="w-full flex justify-end text-end px-2 my-1">
            <Button
              onClick={() => {
                exportExcel(
                  modalData?.data?.map((item, i) => ({
                    "S.N.": i + 1,
                    "Vehicle number": item.registrationNumber,
                    "Last Inspection Date": item.lastInspectionDate ?? null,
                  })),
                  modalData.title.split(" ").join("_") + "_Data"
                );
              }}
              className=" text-blue-500 hover:scale-105 cursor-pointer text-right"
              disabled={!modalData?.data?.length}
            >
              Download
            </Button>
          </h1>
          {modalLoading ? (
            <div className="py-8 flex justify-center">
              <Spinner />
            </div>
          ) : (
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <TH scope="col">S.N.</TH>
                  <TH scope="col">Vehicle Number</TH>
                  <TH scope="col">Last Inspection Date</TH>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {modalData?.data?.length > 0 &&
                  modalData.data.map((vehicle, index) => (
                    <tr key={vehicle.registrationNumber ?? index}>
                      <TD>{index + 1}</TD>
                      <TD>{vehicle.registrationNumber}</TD>
                      <TD>{vehicle.lastInspectionDate}</TD>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </Modal>
      )}
      <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{idx + 1}</TD>
        <TD>{`${data?.fleet} (${data?.fleetCity})`}</TD>
        {reportType === "hub" && <TD>{data?.hubName ?? "N/A"}</TD>}
        <TD>
          <div className="flex gap-2 items-center justify-center">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={() =>
                modalHandler("Inspection Pending " + data?.fleet + " (" + (data?.fleetCity || "-") + ") Total", "total")
              }
            >
              {data?.vehiclesCount ?? 0}
            </span>
          </div>
        </TD>
        <TD>
          <div className="flex gap-2 items-center justify-center">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={() =>
                modalHandler("Inspection Pending " + data?.fleet + " (" + (data?.fleetCity || "-") + ") CPKM", "cpkm")
              }
            >
              {data?.cpkmCount ?? 0}
            </span>
          </div>
        </TD>
        <TD>
          <div className="flex gap-2 items-center justify-center">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={() =>
                modalHandler("Inspection Pending " + data?.fleet + " (" + (data?.fleetCity || "-") + ") Service", "service")
              }
            >
              {data?.serviceCount ?? 0}
            </span>
          </div>
        </TD>
        <TD>
          <div className="flex gap-2 items-center justify-center">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={() =>
                modalHandler("Inspection Pending " + data?.fleet + " (" + (data?.fleetCity || "-") + ") Today", "today")
              }
            >
              {data?.todayCount ?? 0}
            </span>
          </div>
        </TD>
        <TD>
          <div className="flex gap-2 items-center justify-center">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={() =>
                modalHandler(
                  "Inspection Pending " + data?.fleet + " (" + (data?.fleetCity || "-") + ") 1-30 Days",
                  "1-30"
                )
              }
            >
              {(data?.oneToFifteenDaysCount ?? 0) +
                (data?.sixteenToThirtyDaysCount ?? 0)}
            </span>
          </div>
        </TD>
        <TD>
          <div className="flex gap-2 items-center justify-center">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={() =>
                modalHandler(
                  "Inspection Pending " + data?.fleet + " (" + (data?.fleetCity || "-") + ") 31-60 days",
                  "31-60"
                )
              }
            >
              {data?.thirtyOneToSixtyDaysCount ?? 0}
            </span>
          </div>
        </TD>
        <TD>
          <div className="flex gap-2 items-center justify-center">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={() =>
                modalHandler(
                  "Inspection Pending " + data?.fleet + " (" + (data?.fleetCity || "-") + ") 61-90 Days",
                  "61-90"
                )
              }
            >
              {data?.sixtyOneToNintyDaysCount ?? 0}
            </span>
          </div>
        </TD>
        <TD>
          <div className="flex gap-2 items-center justify-center">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={() =>
                modalHandler(
                  "Inspection Pending " + data?.fleet + " (" + (data?.fleetCity || "-") + ") Over 91 Days",
                  "over91"
                )
              }
            >
              {data?.overNinetyDaysCount ?? 0}
            </span>
          </div>
        </TD>
      </tr>
    </Fragment>
  );
};
